import image1 from '../assets/categoryIcons/Bridal Wear.jpg';
import image2 from '../assets/categoryIcons/Bridesmaids_Torrey Fox.jpg';
import image3 from '../assets/categoryIcons/Wedding Guest.jpg';
import image4 from '../assets/categoryIcons/image4.png';
import gownImage from '../assets/image/gown.png';
import accessoriesImage from '../assets/image/accessories.png';
import dressImage from '../assets/image/dress.png';
import shoeImage from '../assets/image/shoe.png';
//////////////////////////////////////////////////////////////////////
// Configurations related to search                                 //
// Note: some search experience is also on defaultMapsConfig        //
// and defaultListingConfig.js is responsible public data filtering //
//////////////////////////////////////////////////////////////////////

// NOTE: if you want to change the structure of the data,
// you should also check src/util/configHelpers.js
// some validation is added there.

// Main search used in Topbar.
// This can be either 'keywords' or 'location'.
// Note: The mainSearch comes from the listing-search asset nowadays by default.
//       To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
export const mainSearch = {
  searchType: 'keywords',
};

export const listingMainProductType = [
  { key: 'bridal-wear', label: 'Bridal Wear', image: image1, option: 'bridal-wear' },
  { key: 'bridesMaid', label: 'Bridesmaid', image: image2, option: 'bridesMaid' },
  { key: 'wedding-guests', label: 'Wedding Guests', image: image3, option: 'wedding-guests' },
];

export const listingBridemaidsProductType = [
  { key: 'dresses', label: 'Dresses', image: gownImage, option: 'dresses' },
];

export const listingWeddingGuestProductType = [
  { key: 'attire', label: 'Attire', image: dressImage, option: 'attire' },
  { key: 'accessories', label: 'Accessories', image: accessoriesImage, option: 'accessories' },
  { key: 'shoes', label: 'Shoes', image: shoeImage, option: 'shoes' },
];

export const listingBrideWearProductType = [
  { key: 'gowns', label: 'Wedding Dress', image: gownImage, option: 'gowns' },
  { key: 'accessories', label: 'Accessories', image: accessoriesImage, option: 'accessories' },
  { key: 'occasions', label: 'Bridal Occasions', image: dressImage, option: 'occasions' },
  { key: 'shoes', label: 'Shoes', image: shoeImage, option: 'shoes' },
];

export const listingSearchProductType = [
  { key: 'gowns', label: 'Gowns', image: image1, option: 'gowns' },
  { key: 'accessories', label: 'Accessories', image: image2, option: 'accessories' },
  { key: 'occasions', label: 'Occasions', image: image3, option: 'occasions' },
  { key: 'shoes', label: 'Shoes', image: image4, option: 'shoes' },
];

export const allowNegotiation = [{ key: 'allowed', label: 'Yes' }, { key: 'no', label: 'No' }];

export const originalOwners = [{ key: 'yes', label: 'Yes' }, { key: 'no', label: 'No' }];

export const originalReceipts = [{ key: 'yes', label: 'Yes' }, { key: 'no', label: 'No' }];

export const boxSize = [
  { key: 'small-flat-rate', label: 'Small Flat Rate Box (8.6875 x 5.4375 x 1.75 in)', length: 8.6875, width: 5.4375, height: 1.75, },
  { key: 'medium-flat-rate', label: 'Medium Flat Rate Box 1 (11.25 x 8.75 x 6 in)', length: 11.25, width: 8.75, height: 6, },
  { key: 'large-flat-rate', label: 'Large Flat Rate Box (12.25 x 12.25 x 6 in)', length: 12.25, width: 12.25, height: 6, },
  { key: 'regional-rate', label: 'Regional Rate Box A1 (10.125 x 7.125 x 5 in)', length: 10.125, width: 7.125, height: 5, },
];



export const listingSubAccessories = [
  { key: 'bracelet ', label: 'Bracelet ', parentKey: 'accessories', option: 'bracelet ', parentCategory: "Jewelry" },
  { key: 'earrings', label: 'Earrings', parentKey: 'accessories', option: 'earrings', parentCategory: "Jewelry" },
  { key: 'necklace', label: 'Necklace', parentKey: 'accessories', option: 'necklace', parentCategory: "Jewelry" },
  { key: 'ring', label: 'Ring', parentKey: 'accessories', option: 'ring', parentCategory: "Jewelry" },

  { key: 'blusher', label: 'Blusher', parentKey: 'accessories', option: 'blusher', parentCategory: "Veil" },
  { key: 'cathedral', label: 'Cathedral', parentKey: 'accessories', option: 'cathedral', parentCategory: "Veil" },
  { key: 'chapel', label: 'Chapel', parentKey: 'accessories', option: 'chapel', parentCategory: "Veil" },
  { key: 'finger-tip', label: 'Finger Tip', parentKey: 'accessories', option: 'finger-tip', parentCategory: "Veil" },
  { key: 'knee', label: 'Knee', parentKey: 'accessories', option: 'knee', parentCategory: "Veil" },
  { key: 'shoulder', label: 'Shoulder', parentKey: 'accessories', option: 'shoulder', parentCategory: "Veil" },
  { key: 'waltz', label: 'Waltz', parentKey: 'accessories', option: 'waltz', parentCategory: "Veil" },
  { key: 'other', label: 'Other', parentKey: 'accessories', option: 'other', parentCategory: "Veil" },
  { key: 'other', label: 'Other', parentKey: 'accessories', option: 'other', parentCategory: "Jewelry" },
];

export const listingCategory = [

  { key: 'bridal-gowns', label: 'Wedding Dress', parentKey: ['gowns'], option: 'bridal-gowns' },
  { key: 'gloves', label: 'Gloves', parentKey: ['accessories'], option: 'gloves' },
  { key: 'hair-accessories', label: 'Hair Accessories', parentKey: ['accessories'], option: 'hair-accessories' },
  { key: 'jewelry', label: 'Jewelry', parentKey: ['accessories'], option: 'jewelry' },
  { key: 'purse', label: 'Purse', parentKey: ['accessories'], option: 'purse' },
  { key: 'shawl/cape', label: 'Shawl/Cape', parentKey: ['accessories'], option: 'shawl/cape' },
  { key: 'veil', label: 'Veil', parentKey: ['accessories'], option: 'veil' },

  { key: 'bachelorette-party', label: 'Bachelorette Party', parentKey: ['occasions', 'dresses', 'attire'], option: 'bachelorette-party' },
  { key: 'bridal-shower', label: 'Bridal Shower', parentKey: ['occasions', 'dresses', 'attire'], option: 'bridal-shower' },
  { key: 'courthouse-wedding', label: 'Courthouse Wedding', parentKey: ['occasions', 'dresses'], option: 'courthouse-wedding' },
  { key: 'engagement-party', label: 'Engagement Party', parentKey: ['occasions', 'dresses', 'attire'], option: 'engagement-party' },
  { key: 'engagement-photos', label: 'Engagement Photos', parentKey: ['occasions', 'dresses'], option: 'engagement-photos' },
  { key: 'getting-ready', label: 'Getting Ready', parentKey: ['occasions', 'dresses'], option: 'getting-ready' },
  { key: 'honeymoon', label: 'Honeymoon', parentKey: ['occasions', 'dresses'], option: 'honeymoon' },
  { key: 'reception', label: 'Reception', parentKey: ['occasions', 'dresses'], option: 'reception' },
  { key: 'reception-cocktail-dress', label: 'Reception/Cocktail dress', parentKey: ['occasions', 'dresses'], option: 'reception-cocktail-dress' },
  { key: 'rehearsal/welcome-party', label: 'Rehearsal/Welcome Party', parentKey: ['attire'], option: "rehearsal/welcome-party" },
  { key: 'rehearsal-dinner', label: 'Rehearsal Dinner', parentKey: ['occasions', 'dresses'], option: 'rehearsal-dinner' },
  { key: 'welcome-party', label: 'Welcome Party', parentKey: ['occasions', 'dresses'], option: "welcome-party" },
  { key: 'wedding-brunch', label: 'Wedding Brunch', parentKey: ['occasions', 'dresses'], option: "wedding-brunch" },
  { key: 'wedding-day', label: 'Wedding Day', parentKey: ['attire'], option: "wedding-day" },


  { key: 'other', label: 'Other', parentKey: ['accessories', 'gowns', 'occasions', 'attire'], option: 'other' },
];

export const listingDesigner = [
  { key: 'amsale', label: 'Amsale', parentKey: 'gowns', option: 'amsale' },
  { key: 'anne-barge', label: 'Anne Barge', parentKey: 'gowns', option: 'anne-barge' },
  { key: 'arielle-t', label: 'Arielle T', parentKey: 'gowns', option: 'arielle-t' },
  { key: 'atelier-pronovias', label: 'Atelier Pronovias', parentKey: 'gowns', option: 'atelier-pronovias' },
  { key: 'badgley-mischka', label: 'Badgley Mischka', parentKey: 'gowns', option: 'badgley-mischka' },
  { key: 'berta', label: 'Berta', parentKey: 'gowns', option: 'berta' },
  { key: 'bhldn', label: 'BHLDN (Anthropologie)', parentKey: 'gowns', option: 'bhldn' },
  { key: 'bliss-by-monique-lhuillier', label: 'Bliss by Monique Lhuillier', parentKey: 'gowns', option: 'bliss-by-monique-lhuillier' },
  { key: 'carolina-herrera', label: 'Carolina Herrera', parentKey: 'gowns', option: 'carolina-herrera' },
  { key: 'claire-pettibone', label: 'Claire Pettibone', parentKey: 'gowns', option: 'claire-pettibone' },
  { key: 'costarellos', label: 'Costarellos', parentKey: 'gowns', option: 'costarellos' },
  { key: 'dana-harel', label: 'Dana Harel', parentKey: 'gowns', option: 'dana-harel' },
  { key: 'danielle-frankel', label: 'Danielle Frankel', parentKey: 'gowns', option: 'danielle-frankel' },
  { key: 'davids-bridal-in-house-brands', label: "David's Bridal (in-house brands)", parentKey: 'gowns', option: 'davids-bridal-in-house-brands' },
  { key: 'elie-saab', label: 'Elie Saab', parentKey: 'gowns', option: 'elie-saab' },
  { key: 'elizabeth-fillmore', label: 'Elizabeth Fillmore', parentKey: 'gowns', option: 'elizabeth-fillmore' },
  { key: 'enaura', label: 'Enaura', parentKey: 'gowns', option: 'enaura' },
  { key: 'eva-lendel', label: 'Eva Lendel', parentKey: 'gowns', option: 'eva-lendel' },
  { key: 'galia-lahav', label: 'Galia Lahav', parentKey: 'gowns', option: 'galia-lahav' },
  { key: 'grace-loves-lace', label: 'Grace Loves Lace', parentKey: 'gowns', option: 'grace-loves-lace' },
  { key: 'hayley-paige', label: 'Hayley Paige', parentKey: 'gowns', option: 'hayley-paige' },
  { key: 'hermione-de-paula', label: 'Hermione de Paula', parentKey: 'gowns', option: 'hermione-de-paula' },
  { key: 'ines-di-santo', label: 'Ines Di Santo', parentKey: 'gowns', option: 'ines-di-santo' },
  { key: 'inbal-dror', label: 'Inbal Dror', parentKey: 'gowns', option: 'inbal-dror' },
  { key: 'jenny-packham', label: 'Jenny Packham', parentKey: 'gowns', option: 'jenny-packham' },
  { key: 'justin-alexander', label: 'Justin Alexander', parentKey: 'gowns', option: 'justin-alexander' },
  { key: 'julie-vino', label: 'Julie Vino', parentKey: 'gowns', option: 'julie-vino' },
  { key: 'katherine-tash', label: 'Katherine Tash', parentKey: 'gowns', option: 'katherine-tash' },
  { key: 'lazaro', label: 'Lazaro', parentKey: 'gowns', option: 'lazaro' },
  { key: 'leanne-marshall', label: 'Leanne Marshall', parentKey: 'gowns', option: 'leanne-marshall' },
  { key: 'lela-rose', label: 'Lela Rose', parentKey: 'gowns', option: 'lela-rose' },
  { key: 'marchesa', label: 'Marchesa', parentKey: 'gowns', option: 'marchesa' },
  { key: 'markarian', label: 'Markarian', parentKey: 'gowns', option: 'markarian' },
  { key: 'milla-nova', label: 'Milla Nova', parentKey: 'gowns', option: 'milla-nova' },
  { key: 'mira-zwillinger', label: 'Mira Zwillinger', parentKey: 'gowns', option: 'mira-zwillinger' },
  { key: 'monique-lhuillier', label: 'Monique Lhuillier', parentKey: 'gowns', option: 'monique-lhuillier' },
  { key: 'morilee-by-madeline-gardner', label: 'Morilee by Madeline Gardner', parentKey: 'gowns', option: 'morilee-by-madeline-gardner' },
  { key: 'naama-anat', label: 'Naama & Anat', parentKey: 'gowns', option: 'naama-anat' },
  { key: 'naeem-khan', label: 'Naeem Khan', parentKey: 'gowns', option: 'naeem-khan' },
  { key: 'natalie-wynn', label: 'Natalie Wynn', parentKey: 'gowns', option: 'natalie-wynn' },
  { key: 'nicole-milano', label: 'Nicole Milano', parentKey: 'gowns', option: 'nicole-milano' },
  { key: 'oscar-de-la-renta', label: 'Oscar de la Renta', parentKey: 'gowns', option: 'oscar-de-la-renta' },
  { key: 'pallas-couture', label: 'Pallas Couture', parentKey: 'gowns', option: 'pallas-couture' },
  { key: 'peter-langner', label: 'Peter Langner', parentKey: 'gowns', option: 'peter-langner' },
  { key: 'pnina-tornai', label: 'Pnina Tornai', parentKey: 'gowns', option: 'pnina-tornai' },
  { key: 'pronovias', label: 'Pronovias', parentKey: 'gowns', option: 'pronovias' },
  { key: 'reem-acra', label: 'Reem Acra', parentKey: 'gowns', option: 'reem-acra' },
  { key: 'rime-arodaky', label: 'Rime Arodaky', parentKey: 'gowns', option: 'rime-arodaky' },
  { key: 'rosa-clara', label: 'Rosa Clará', parentKey: 'gowns', option: 'rosa-clara' },
  { key: 'rue-de-seine', label: 'Rue De Seine', parentKey: 'gowns', option: 'rue-de-seine' },
  { key: 'sarah-seven', label: 'Sarah Seven', parentKey: 'gowns', option: 'sarah-seven' },
  { key: 'savannah-miller', label: 'Savannah Miller', parentKey: 'gowns', option: 'savannah-miller' },
  { key: 'sachin-babi', label: 'Sachin & Babi', parentKey: 'gowns', option: 'sachin-babi' },
  { key: 'sassi-holford', label: 'Sassi Holford', parentKey: 'gowns', option: 'sassi-holford' },
  { key: 'suzanne-neville', label: 'Suzanne Neville', parentKey: 'gowns', option: 'suzanne-neville' },
  { key: 'temperley-london', label: 'Temperley London', parentKey: 'gowns', option: 'temperley-london' },
  { key: 'theia', label: 'Theia', parentKey: 'gowns', option: 'theia' },
  { key: 'toni-maticevski', label: 'Toni Maticevski', parentKey: 'gowns', option: 'toni-maticevski' },
  { key: 'vera-wang', label: 'Vera Wang', parentKey: 'gowns', option: 'vera-wang' },
  { key: 'watters', label: 'Watters', parentKey: 'gowns', option: 'watters' },
  { key: 'willowby-by-watters', label: 'Willowby by Watters', parentKey: 'gowns', option: 'willowby-by-watters' },
  { key: 'wtoo-by-watters', label: 'Wtoo by Watters', parentKey: 'gowns', option: 'wtoo-by-watters' },
  { key: 'zuhair-murad', label: 'Zuhair Murad', parentKey: 'gowns', option: 'zuhair-murad' },
  { key: 'other', label: 'Other', parentKey: 'gowns', option: 'other' },
];


export const listingRole = [
  { key: 'bridesmaid', label: 'Bridesmaid', parentKey: ['gowns', 'occasions'], option: 'bridal-gowns' },
  { key: 'flower-Girl', label: 'Flower Girl', parentKey: ['gowns', 'occasions'], option: 'bridal-gowns' },
  { key: 'mother-of-the-bride', label: 'Mother Of the Bride', parentKey: ['gowns', 'occasions'], option: 'bridal-gowns' },
  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions'], option: 'other' },
]


export const listingSize = [
  { key: '0', label: '0', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '0' },
  { key: '2', label: '2', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '2' },
  { key: '4', label: '4', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '4' },
  { key: '6', label: '6', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '6' },
  { key: '8', label: '8', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '8' },
  { key: '10', label: '10', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '10' },
  { key: '12', label: '12', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '12' },
  { key: '14', label: '14', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '14' },
  { key: '16', label: '16', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '16' },
  { key: '18', label: '18', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '18' },
  { key: '20', label: '20', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '20' },
  { key: '22', label: '22', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '22' },
  { key: '24+', label: '24+', parentKey: ['gowns', 'occasions', 'attire', 'dresses'], option: '24+' },


  { key: '5', label: '5', parentKey: ['shoes'], option: '5' },
  { key: '5.5', label: '5.5', parentKey: ['shoes'], option: '5.5' },
  { key: '6', label: '6', parentKey: ['shoes'], option: '6' },
  { key: '6.5', label: '6.5', parentKey: ['shoes'], option: '6.5' },
  { key: '7', label: '7', parentKey: ['shoes'], option: '7' },
  { key: '7.5', label: '7.5', parentKey: ['shoes'], option: '7.5' },
  { key: '8', label: '8', parentKey: ['shoes'], option: '8' },
  { key: '8.5', label: '8.5', parentKey: ['shoes'], option: '8.5' },
  { key: '9', label: '9', parentKey: ['shoes'], option: '9' },
  { key: '9.5', label: '9.5', parentKey: ['shoes'], option: '9.5' },
  { key: '10', label: '10', parentKey: ['shoes'], option: '10' },
  { key: '10.5', label: '10.5', parentKey: ['shoes'], option: '10.5' },
  { key: '11', label: '11', parentKey: ['shoes'], option: '11' },
  { key: '11.5', label: '11.5', parentKey: ['shoes'], option: '11.5' },
  { key: '12', label: '12', parentKey: ['shoes'], option: '12' },

];

export const listingStreetSize = [
  { key: '0', label: '0', parentKey: 'gowns', option: '0' },
  { key: '2', label: '2', parentKey: 'gowns', option: '2' },
  { key: '4', label: '4', parentKey: 'gowns', option: '4' },
  { key: '6', label: '6', parentKey: 'gowns', option: '6' },
  { key: '8', label: '8', parentKey: 'gowns', option: '8' },
  { key: '10', label: '10', parentKey: 'gowns', option: '10' },
  { key: '12', label: '12', parentKey: 'gowns', option: '12' },
  { key: '14', label: '14', parentKey: 'gowns', option: '14' },
  { key: '16', label: '16', parentKey: 'gowns', option: '16' },
  { key: '18', label: '18', parentKey: 'gowns', option: '18' },
  { key: '20', label: '20', parentKey: 'gowns', option: '20' },
  { key: '22', label: '22', parentKey: 'gowns', option: '22' },
  { key: '24+', label: '24+', parentKey: 'gowns', option: '24+' },
];

export const listingHeelHeight = [
  { key: '0-inches', label: '0 inches', option: '0-inches' },
  { key: '1-2-inches', label: '1-2 inches', option: '1-2-inches' },
  { key: '2-3-inches', label: '2-3 inches', option: '2-3-inches' },
  { key: '4+-inches', label: '4+ inches', option: '4+-inches' },
  { key: 'other', label: 'Other', option: 'other' },
];

export const listingMaterial = [
  { key: 'batiste', label: 'Batiste', parentKey: 'gowns', option: 'batiste' },
  { key: 'brocade', label: 'Brocade', parentKey: 'gowns', option: 'brocade' },
  { key: 'charmeuse', label: 'Charmeuse', parentKey: 'gowns', option: 'charmeuse' },
  { key: 'chiffon', label: 'Chiffon', parentKey: 'gowns', option: 'chiffon' },
  { key: 'crepe', label: 'Crepe', parentKey: 'gowns', option: 'crepe' },
  { key: 'damask', label: 'Damask', parentKey: 'gowns', option: 'damask' },
  { key: 'duchesse', label: 'Duchesse', parentKey: 'gowns', option: 'duchesse' },
  { key: 'georgette', label: 'Georgette', parentKey: 'gowns', option: 'georgette' },
  { key: 'lace', label: 'Lace', parentKey: 'gowns', option: 'lace' },
  { key: 'mikado', label: 'Mikado', parentKey: 'gowns', option: 'mikado' },
  { key: 'organza', label: 'Organza', parentKey: 'gowns', option: 'organza' },
  { key: 'pique', label: 'Pique', parentKey: 'gowns', option: 'pique' },
  { key: 'polyester', label: 'Polyester', parentKey: 'gowns', option: 'polyester' },
  { key: 'satin', label: 'Satin', parentKey: 'gowns', option: 'satin' },
  { key: 'silk', label: 'Silk', parentKey: 'gowns', option: 'silk' },
  { key: 'silk-dupioni', label: 'Silk Dupioni', parentKey: 'gowns', option: 'silk-dupioni' },
  { key: 'taffeta', label: 'Taffeta', parentKey: 'gowns', option: 'taffeta' },
  { key: 'tulle', label: 'Tulle', parentKey: 'gowns', option: 'tulle' },
  { key: 'velvet', label: 'Velvet', parentKey: 'gowns', option: 'velvet' },
  { key: 'voile', label: 'Voile', parentKey: 'gowns', option: 'voile' },
  { key: 'wool', label: 'Wool', parentKey: 'gowns', option: 'wool' },
  { key: 'other', label: 'Other', parentKey: 'gowns', option: 'other' },
];

export const listingNeckline = [
  { key: 'cowl-neck', label: 'Cowl Neck', parentKey: 'gowns', option: 'cowl-neck' },
  { key: 'halter', label: 'Halter', parentKey: 'gowns', option: 'halter' },
  { key: 'high-neck', label: 'High Neck', parentKey: 'gowns', option: 'high-neck' },
  { key: 'off-the-shoulder', label: 'Off The Shoulder', parentKey: 'gowns', option: 'off-the-shoulder' },
  { key: 'one-shoulder', label: 'One Shoulder', parentKey: 'gowns', option: 'one-shoulder' },
  { key: 'plunging-neckline', label: 'Plunging Neckline', parentKey: 'gowns', option: 'plunging-neckline' },
  { key: 'square-neck', label: 'Square Neck', parentKey: 'gowns', option: 'square-neck' },
  { key: 'strapless', label: 'Strapless', parentKey: 'gowns', option: 'strapless' },
  { key: 'sweetheart', label: 'Sweetheart', parentKey: 'gowns', option: 'sweetheart' },
  { key: 'other', label: 'Other', parentKey: 'gowns', option: 'other' },
];

export const listingSleeves = [
  { key: 'cap-sleeve', label: 'Cap Sleeve', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'cap-sleeve' },
  { key: 'long-sleeve', label: 'Long Sleeve', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'long-sleeve' },
  { key: 'puff-sleeve', label: 'Puff Sleeve', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'puff-sleeve' },
  { key: 'removable-sleeves', label: 'Removable Sleeves', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'removable-sleeves' },
  { key: 'short-sleeve', label: 'Short Sleeve', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'short-sleeve' },
  { key: 'sleeveless', label: 'Sleeveless', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'sleeveless' },
  { key: 'spaghetti-straps', label: 'Spaghetti Straps', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'spaghetti-straps' },
  { key: 'thick-straps', label: 'Thick Straps', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'thick-straps' },
  { key: 'three-quarter-sleeves', label: 'Three-Quarter Sleeves', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'three-quarter-sleeves' },
  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'other' },
];

export const listingLength = [
  { key: 'mini', label: 'Mini', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'mini' },
  { key: 'midi', label: 'Midi', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'midi' },
  { key: 'maxi', label: 'Maxi', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'maxi' },
  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: 'other' },
];

export const listingColor = [
  { key: 'black', label: 'Black', parentKey: ['dresses', 'accessories', 'shoes', 'attire'], option: "black" },
  { key: 'blue', label: 'Blue', parentKey: ['accessories', 'dresses', 'shoes', 'attire'], option: "blue" },
  { key: 'brown', label: 'Brown', parentKey: ['shoes'], option: "brown" },
  { key: 'champagne', label: 'Champagne', parentKey: ['gowns', 'occasions'], option: "champagne" },
  { key: 'clear', label: 'Clear', parentKey: ['shoes'], option: "clear" },
  { key: 'embellished', label: 'Embellished', parentKey: ['gowns', 'occasions'], option: "embellished" },
  { key: 'gold', label: 'Gold', parentKey: ['dresses', 'accessories', 'shoes', 'attire'], option: "gold" },
  { key: 'green', label: 'Green', parentKey: ['dresses', 'accessories', 'shoes', 'attire'], option: "green" },
  { key: 'ivory', label: 'Ivory', parentKey: ['gowns', 'occasions', 'accessories', 'shoes'], option: "ivory" },
  {
    key: 'multi-color',
    label: 'Multi-Color',
    parentKey: ['gowns', 'occasions', 'accessories', 'shoes']
    , option: "multi-color"
  },
  { key: 'orange', label: 'Orange', parentKey: ['accessories', 'dresses', 'shoes', 'attire'], option: "orange" },
  { key: 'pink', label: 'Pink', parentKey: ['accessories', 'dresses', 'shoes', 'attire'], option: "pink" },
  { key: 'purple', label: 'Purple', parentKey: ['dresses', 'accessories', 'shoes', 'attire'], option: "purple" },
  { key: 'red', label: 'Red', parentKey: ['dresses', 'attire', 'accessories', 'shoes'], option: "red" },
  { key: 'sequin', label: 'Sequin', parentKey: ['gowns', 'occasions'], option: "sequin" },
  { key: 'silver', label: 'Silver', parentKey: ['accessories', 'dresses', 'attire', 'shoes'], option: "silver" },
  { key: 'tan', label: 'Tan', parentKey: ['shoes'], option: "tan" },
  { key: 'white', label: 'White', parentKey: ['gowns', 'occasions', 'accessories', 'dresses', 'attire', 'shoes'], option: "white" },
  { key: 'yellow', label: 'Yellow', parentKey: ['dresses', 'attire', 'accessories', 'shoes'], option: "yellow" },

  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions', 'dresses', 'attire', 'accessories', 'shoes'], option: "other" },
];

export const listingBrand = [
  { key: 'amsale', label: 'Amsale Bridesmaids', parentKey: 'dresses', option: 'amsale' },
  { key: 'azazie', label: 'Azazie', parentKey: 'dresses', option: 'azazie' },
  { key: 'bari-jay', label: 'Bari Jay', parentKey: 'dresses', option: 'bari-jay' },
  { key: 'birdy-grey', label: 'Birdy Grey', parentKey: 'dresses', option: 'birdy-grey' },
  { key: 'bhldn', label: 'BHLDN (Anthropologie)', parentKey: 'dresses', option: 'bhldn' },
  { key: 'bill-levkoff', label: 'Bill Levkoff', parentKey: 'dresses', option: 'bill-levkoff' },
  { key: 'brideside', label: 'Brideside (now part of The Dessy Group)', parentKey: 'dresses', option: 'brideside' },
  { key: 'cocomelody', label: 'Cocomelody', parentKey: 'dresses', option: 'cocomelody' },
  { key: 'dessy-collection', label: 'Dessy Collection', parentKey: 'dresses', option: 'dessy-collection' },
  { key: 'davids-bridal', label: 'David’s Bridal', parentKey: 'dresses', option: 'davids-bridal' },
  { key: 'dear-cleo', label: 'Dear Cleo', parentKey: 'dresses', option: 'dear-cleo' },
  { key: 'jenny-yoo', label: 'Jenny Yoo Collection', parentKey: 'dresses', option: 'jenny-yoo' },
  { key: 'hayley-paige-occasions', label: 'Hayley Paige Occasions', parentKey: 'dresses', option: 'hayley-paige-occasions' },
  { key: 'jasmine-bridal', label: 'Jasmine Bridal', parentKey: 'dresses', option: 'jasmine-bridal' },
  { key: 'joanna-august', label: 'Joanna August', parentKey: 'dresses', option: 'joanna-august' },
  { key: 'kennedy-blue', label: 'Kennedy Blue', parentKey: 'dresses', option: 'kennedy-blue' },
  { key: 'lulus', label: 'Lulus', parentKey: 'dresses', option: 'lulus' },
  { key: 'morilee-by-madeline-gardner', label: 'Morilee by Madeline Gardner', parentKey: 'dresses', option: 'morilee-by-madeline-gardner' },
  { key: 'monique-lhuillier-bridesmaids', label: 'Monique Lhuillier Bridesmaids', parentKey: 'dresses', option: 'monique-lhuillier-bridesmaids' },
  { key: 'nordstrom', label: 'Nordstrom (in-house & designer collections)', parentKey: 'dresses', option: 'nordstrom' },
  { key: 'show-me-your-mumu', label: 'Show Me Your Mumu', parentKey: 'dresses', option: 'show-me-your-mumu' },
  { key: 'shona-joy', label: 'Shona Joy', parentKey: 'dresses', option: 'shona-joy' },
  { key: 'reformation', label: 'Reformation', parentKey: 'dresses', option: 'reformation' },
  { key: 'revelry', label: 'Revelry', parentKey: 'dresses', option: 'revelry' },
  { key: 'sorella-vita', label: 'Sorella Vita', parentKey: 'dresses', option: 'sorella-vita' },
  { key: 'sachin-babi', label: 'Sachin & Babi Bridesmaids', parentKey: 'dresses', option: 'sachin-babi' },
  { key: 'tulle-chantilly', label: 'Tulle & Chantilly', parentKey: 'dresses', option: 'tulle-chantilly' },
  { key: 'twobirds', label: 'Twobirds', parentKey: 'dresses', option: 'twobirds' },
  { key: 'watters-bridesmaids', label: 'Watters Bridesmaids', parentKey: 'dresses', option: 'watters-bridesmaids' },
  { key: 'wtoo-by-watters', label: 'Wtoo by Watters', parentKey: 'dresses', option: 'wtoo-by-watters' },
  { key: 'willowby-by-watters', label: 'Willowby by Watters', parentKey: 'dresses', option: 'willowby-by-watters' },
  { key: 'windsor', label: 'Windsor', parentKey: 'dresses', option: 'windsor' },
  { key: 'other', label: 'Other', parentKey: 'dresses', option: 'other' }
];

export const listingStyle = [
  { key: 'a-line', label: 'A-Line', parentKey: ['gowns'], option: "a-line" },
  { key: 'ball-gown', label: 'Ball Gown', parentKey: ['gowns'], option: "ball-gown" },
  { key: 'column', label: 'Column', parentKey: ['gowns'], option: "column" },
  { key: 'drop-waist', label: 'Drop Waist', parentKey: ['gowns'], option: "drop-waist" },
  { key: 'empire', label: 'Empire', parentKey: ['gowns'], option: "empire" },
  { key: 'fit-flare', label: 'Fit & Flare', parentKey: ['gowns'], option: "fit-flare" },
  { key: 'mermaid', label: 'Mermaid', parentKey: ['gowns'], option: "mermaid" },
  { key: 'slip', label: 'Slip', parentKey: ['gowns'], option: "slip" },
  { key: 'trumpet', label: 'Trumpet', parentKey: ['gowns'], option: "trumpet" },

  { key: 'block-heel', label: 'Block Heel', parentKey: ['shoes'], option: "block-heel" },
  { key: 'closed-toe', label: 'Closed Toe', parentKey: ['shoes'], option: "closed-toe" },
  { key: 'mule', label: 'Mule', parentKey: ['shoes'], option: "mule" },
  { key: 'open-toe', label: 'Open Toe', parentKey: ['shoes'], option: "open-toe" },
  { key: 'platform', label: 'Platform', parentKey: ['shoes'], option: "platform" },
  { key: 'sneaker', label: 'Sneaker', parentKey: ['shoes'], option: "sneaker" },
  { key: 'stiletto', label: 'Stiletto', parentKey: ['shoes'], option: "stiletto" },


  { key: 'blazer', label: 'Blazer', parentKey: ['occasions', 'dresses'], option: "blazer" },
  { key: 'dress', label: 'Dress', parentKey: ['occasions', 'dresses', 'attire'], option: "dress" },
  { key: 'jumpsuit', label: 'Jumpsuit', parentKey: ['occasions', 'dresses', 'attire'], option: "jumpsuit" },
  { key: 'pants', label: 'Pants', parentKey: ['occasions', 'dresses', 'attire'], option: "pants" },
  { key: 'skirt', label: 'Skirt', parentKey: ['occasions', 'dresses', 'attire'], option: "skirt" },
  { key: 'top', label: 'Top', parentKey: ['occasions', 'dresses', 'attire'], option: "top" },

  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions', 'dresses', 'attire', 'shoes'], option: "other" },

];


export const listingEvents = [
  { key: 'bachelorette-party', label: 'Bachelorette Party', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "bachelorette-party" },
  { key: 'bridal-shower', label: 'Bridal Shower', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "bridal-shower" },
  { key: 'engagement-party', label: 'Engagement Party', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "engagement-party" },
  { key: 'rehearsal-dinner', label: 'Rehearsal Dinner', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "rehearsal-dinner" },
  { key: 'welcome-party', label: 'Welcome Party', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "welcome-party" },
  { key: 'wedding-brunch', label: 'Wedding Brunch', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "wedding-brunch" },
  { key: 'wedding-day', label: 'Wedding Day', parentKey: ['attire'], option: "wedding-day" },


  { key: 'other', label: 'Other', parentKey: ['gowns', 'occasions', 'dresses', 'attire'], option: "other" },
];

/**
 * Configuration for default filters.
 * These are custom configs for each filter.
 * Common properties: key, schemaType, and label.
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */

export const dateRangeFilter = {
  schemaType: 'dates',
  // Should the entire date range be available, or just part of it
  // Note: Since we don't enforce location search for dates filtering,
  //       we don't use API's 'time-full' in actual queries. It would require time zone info.
  availability: 'time-full', // time-partial
  // Options: day/night. This affects counting and whether single day picking is possible.
  dateRangeMode: 'day',
};

/**
 * Note: the order of default filters is defined in util/configHelpers.js
 * To use this built-in configuration, you need to remove the overwrite from configHelper.js (mergeSearchConfig func)
 */
export const priceFilter = {
  schemaType: 'price',
  // Note: unlike most prices this is not handled in subunits
  min: 0,
  max: 1000,
  step: 5,
};

// // This is not in use by default.
// export const keywordsFilter = {
//   key: 'keywords',
//   schemaType: 'keywords',
// }


export const sortConfig = {
  // Enable/disable the sorting control in the SearchPage
  active: true,

  // Note: queryParamName 'sort' is fixed,
  // you can't change it since Marketplace API expects it to be named as 'sort'
  queryParamName: 'sort',

  // Internal key for the relevance option, see notes below.
  relevanceKey: 'relevance',

  // Relevance key is used with keywords filter.
  // Keywords filter also sorts results according to relevance.
  relevanceFilter: 'keywords',

  // Keyword filter is sorting the results by relevance.
  // If keyword filter is active, one might want to disable other sorting options
  // by adding 'keywords' to this list.
  conflictingFilters: [],

  options: [
    // These are default sort options
    { key: 'createdAt', labelTranslationKey: 'SortBy.newest' },
    // { key: '-createdAt', labelTranslationKey: 'SortBy.oldest' },
    { key: '-price', labelTranslationKey: 'SortBy.lowestPrice' },
    { key: 'price', labelTranslationKey: 'SortBy.highestPrice' },
    // If you add own sort options, you can also use label key: { key: 'meta_rating', label: 'Highest rated' },

    // The relevance is only used for keyword search, but the
    // parameter isn't sent to the Marketplace API. The key is purely
    // for handling the internal state of the sorting dropdown.
    // {
    //   key: 'relevance',
    //   labelTranslationKey: 'SortBy.relevance',
    //   labelTranslationKeyLong: 'SortBy.relevanceLong',
    // },
  ],
};
